export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 2-4_08.314acd92.jpg";